export const SITE_URL = 'https://vehicle-logbook.top';
export const SITE_NAME = 'Vehicle Logbook';
export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export type SeoPageKey = 'home' | 'about' | 'login' | 'register';

export const PUBLIC_PATHS: SeoPageKey[] = [
  'home',
  'about',
  'login',
  'register',
];

export const pathToSeoKey = (pathname: string): SeoPageKey | null => {
  if (pathname === '/') return 'home';
  if (pathname === '/about') return 'about';
  if (pathname === '/login') return 'login';
  if (pathname === '/register') return 'register';
  return null;
};

export const seoKeyToPath = (key: SeoPageKey): string => {
  if (key === 'home') return '/';
  return `/${key}`;
};
